import { MessageInstance } from 'antd/es/message/interface';

export const messageUtils = {
  message: {} as MessageInstance,
};
